<script>
    /**
     @typedef product
     @type {object}
     @property {string} image_checkout_big
     @property {string} image_checkout_small
     */
    import axios from './axios/axiosbootstrap.js';
    import i18n from './plugins/i18n.js';
    import MaskedInput from "vue-masked-input";
    import VueGallery from './gallery.vue';
    import VueNumberInput from '@chenfengyuan/vue-number-input';

    export default {
        i18n,
        name: "Order",
        props: ['initCartData', 'initOrderData', 'links', 'combinations', 'cartItems',],
        data: function () {
            return {
                cart: this.initCartData,
                shipments: this.initOrderData.shipments,
                payments: this.initOrderData.payments,
                firstname: '',
                phone: '',
                shipment_id: this.initOrderData.shipments ? this.initOrderData.shipments[0].id : null,
                payment_id: null,
                is_success: false,
                processed: false,
                errors: []
            };
        },
        components: {
            'gallery': VueGallery,
            'masked-input': MaskedInput,
            'number-input': VueNumberInput
        },
        computed: {
            hasErrors: function () {
                return this.errors.length > 0;
            },
            shipment: function () {
                const shipment = this.shipments.find(shipment => shipment.id === this.shipment_id);
                return typeof shipment !== 'undefined' ? shipment : {
                    id: null,
                    image: '',
                    name: '',
                    description: '',
                    payments: []
                };
            },
            actualPayments: function () {
                return this.payments.filter((payment) => {
                    return this.shipment.payments ? this.shipment.payments.indexOf(payment.id) > -1 : false;
                });
            },
            payment: function () {
                const payment = this.payments.find(payment => payment.id === this.payment_id);
                return typeof payment !== 'undefined' ? payment : {
                    id: null,
                    image: '',
                    name: '',
                    description: '',
                };
            },
        },
        methods: {
            combinationName: function (id) {
                const combination = this.combinations.find(product => product.id === id);
                return typeof combination !== 'undefined' ? combination.name : '';
            },
            checkout: function () {
                this.processed = true;
                this.errors = [];
                axios({
                    url: this.links.checkout_middle,
                    data: {
                        firstname: this.firstname,
                        phone: this.phone,
                        catalog_shipment_id: this.shipment_id,
                        catalog_payment_id: this.payment_id,
                    },
                }).then((response) => {
                    switch (response.status) {
                        case 200:
                            this.is_success = true;
                            this.cart = response.data.cart;
                            window.$('#middle_cart_counter').html(response.data.cart.quantity);
                            window.$.fancybox.open({src: '#done', type: 'inline'});
                            try {
                                if ('analitics' in response.data) {
                                    eval(response.data.analitics);
                                }
                            } catch (e) {
                                console.log(e.message);
                            }
                            break;
                        case 302 || 301:
                            window.location.replace(response.headers['x-redirect']);
                            break;
                        default:
                            if (typeof response.data.errors !== 'undefined') {
                                for (let index in response.data.errors) {
                                    if (response.data.errors.hasOwnProperty(index)) {
                                        this.errors.push(response.data.errors[index].join());
                                    }
                                }
                            }
                            break;
                    }
                }).catch((responce => {
                    this.processed = false;
                })).then((responce => {
                    this.processed = false;
                }))
            },
            deletePosition: function (positionId) {
                this.processed = true;
                this.errors = [];
                axios({
                    url: this.links.middle_cart.del,
                    data: {
                        id: positionId,
                    },
                }).then((response) => {
                    switch (response.status) {
                        case 200:
                            this.is_success = true;
                            this.cart = response.data.cart;
                            window.$('#middle_cart_counter').html(response.data.cart.quantity);
                            break;
                        case 302 || 301:
                            window.location.replace(response.headers['x-redirect']);
                            break;
                        default:
                            if (typeof response.data.errors !== 'undefined') {
                                for (let index in response.data.errors) {
                                    if (response.data.errors.hasOwnProperty(index)) {
                                        this.errors.push(response.data.errors[index].join());
                                    }
                                }
                            }
                            break;
                    }
                }).catch((responce => {
                    this.processed = false;
                })).then((responce => {
                    this.processed = false;
                }))
            },
            updatePositionCount: _.debounce(function (positionId, positionCount) {
                if (this.processed) return;
                this.processed = true;
                this.errors = [];
                axios({
                    url: this.links.middle_cart.count,
                    data: {
                        id: positionId,
                        count: positionCount
                    },
                }).then((response) => {
                    this.processed = false;
                    switch (response.status) {
                        case 200:
                            this.is_success = true;
                            this.cart = response.data.cart;
                            window.$('#middle_cart_counter').html(response.data.cart.quantity);
                            break;
                        case 302 || 301:
                            window.location.replace(response.headers['x-redirect']);
                            break;
                        default:
                            if (typeof response.data.errors !== 'undefined') {
                                for (let index in response.data.errors) {
                                    if (response.data.errors.hasOwnProperty(index)) {
                                        this.errors.push(response.data.errors[index].join());
                                    }
                                }
                            }
                            break;
                    }
                }).catch((responce => {
                    this.processed = false;
                })).then((responce => {
                    this.processed = false;
                }))
            }, 300),
        }
    }
</script>

<template>
    <div class="order">
        <div class="row" v-if="!cart.is_empty">
            <div class="col-md-12">
                <table class="order-table">
                    <thead>
                    <tr>
                        <th class="img">{{$t('cart.image')}}</th>
                        <th class="name">{{$t('cart.name')}}</th>
                        <th class="cost">{{$t('cart.cost')}}</th>
                        <th class="sale">{{$t('cart.sale')}}</th>
                        <th class="qty">{{$t('cart.quantity')}}</th>
                        <th class="total">{{$t('cart.total')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="model in cart.models">
                        <td class="img">
                            <a :href="model.url"><img :src="model.image" :alt="model.name"></a>
                        </td>
                        <td class="name">
                            <a :href="model.url">{{ model.name }}</a>
                            <div class="name-cats">
                                <p>
                                    <span>{{$t('cart.sku')}}:</span>
                                    <span>{{ model.sku }}</span>
                                </p>
                                <p>
                                    <span>{{$t('cart.combination')}}:</span>
                                    <span>{{combinationName(model.com_id)}}</span>
                                </p>
                            </div>
                        </td>
                        <td class="cost" :data-label="$t('cart.cost')">
                            <span>
                                <s v-if="model.discount">{{ model.base_price }}</s><br v-if="model.discount">
                                {{ model.price }}
                            </span>
                        </td>
                        <td class="sale" :data-label="$t('cart.sale')">
                            <span>{{ model.discount_value }}({{ model.discount_percent }})</span>
                        </td>
                        <td class="qty">
                            <number-input
                                    :min="1"
                                    :max="model.cart_position_quantity_max"
                                    :disabled="processed"
                                    v-model="model.cart_position_quantity"
                                    @change="updatePositionCount(model.cart_position_id, model.cart_position_quantity)"
                                    name="quantity"
                                    inline
                                    center
                                    controls
                            ></number-input>
                        </td>
                        <td class="total" :data-label="$t('cart.total')">
                            <span>{{ model.price * model.cart_position_quantity }}</span>
                            <button type="button" class="item-del"
                                    @click="deletePosition(model.cart_position_id)">
                                <svg class="icon">
                                    <use xlink:href="#ic-close"></use>
                                </svg>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-12">
                <div class="row flex-lg-row-reverse">
                    <div class="col-lg-6">
                        <ul class="order-results">
                            <!--<li>
                                <p class="order-results__title">{{$t('cart.total')}}:</p>
                                <p>{{ cart.summ }}</p>
                            </li>-->
                            <!--<li>
                                <p class="order-results__title">{{$t('cart.discount')}}:</p>
                                <p>{{ cart.discount }} ({{ cart.discount_percent }})</p>
                            </li>-->
                            <li>
                                <p class="order-results__title">{{$t('cart.total_quantity')}}:</p>
                                <p>{{ cart.quantity_formatted }}</p>
                            </li>
                            <li>
                                <p class="order-results__title">{{$t('cart.all_total')}}:</p>
                                <p>{{ cart.total_summ }}</p>
                            </li>
                        </ul>
                        <p class="order-results" v-if="payment.description">
                            {{ payment.description }}
                        </p>
                    </div>
                    <div class="col-lg-6">
                        <form class="card-form" :action="links.checkout_middle" method="post"
                              @submit.prevent="checkout">
                            <h3 class="card-form__title">{{ $t('cart.make_order_title') }}</h3>
                            <div class="form-item">
                                <label class="label">
                                    <input class="input"
                                           type="text"
                                           name="firstname"
                                           required
                                           :placeholder="$t('order.fio')"
                                           v-model="firstname"
                                    >
                                </label>
                            </div>
                            <div class="form-item">
                                <label class="label">
                                    <masked-input class="input"
                                                  type="tel"
                                                  name="phone"
                                                  mask="\+\38 (111) 111-1111"
                                                  required
                                                  :placeholder="$t('order.phone')"
                                                  v-model="phone"
                                    />
                                </label>
                            </div>
                            <div class="form-item">
                                <label class="label">
                                    <select name="shipment_id" v-model="shipment_id">
                                        <option v-for="shipment in shipments" v-bind:value="shipment.id">
                                            {{ shipment.name }}
                                        </option>
                                    </select>
                                </label>
                            </div>
                            <div class="order-input" v-if="shipment.id==='new_post'">
                                <div class="form-item">
                                    <label class="label">
                                        <input class="input" type="text" v-bind:placeholder="$t('cart.area')">
                                    </label>
                                </div>
                                <div class="form-item">
                                    <label class="label">
                                        <input class="input" type="text" v-bind:placeholder="$t('cart.city')">
                                    </label>
                                </div>
                                <div class="form-item">
                                    <label class="label">
                                        <input class="input" type="text" v-bind:placeholder="$t('cart.warehous')">
                                    </label>
                                </div>
                            </div>
                            <div class="order-input" v-else>
                                <div class="form-item">
                                    <label class="label">
                                        <input class="input" type="text" v-bind:placeholder="$t('cart.full_address')">
                                    </label>
                                </div>
                            </div>
                            <div class="form-item">
                                <label class="label">
                                    <select name="payment_id" v-model="payment_id">
                                        <option :value="null" disabled>Способ оплаты</option>
                                        <option v-for="payment in actualPayments" v-bind:value="payment.id">
                                            {{ payment.name }}
                                        </option>
                                    </select>
                                </label>
                            </div>
                            <div class="row min">
                                <div class="col-lg-6">
                                    <a class="btn btn-solid" :href="links.catalog">
                                        {{$t('product.to_catalog')}}
                                    </a>
                                </div>
                                <div class="col-lg-6">
                                    <button class="btn" type="submit">{{$t('order.make_order')}}</button>
                                </div>
                            </div>
                            <div class="error-summary" v-show="hasErrors">
                                <p>{{$t('modal.error')}}</p>
                                <ul>
                                    <li v-for="error in errors">{{error}}</li>
                                </ul>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="cart.is_empty">
            <div class="col-md-12">
                <div class="order-empty">
                    <svg class="icon">
                        <use xlink:href="#ic-cart-empty"></use>
                    </svg>
                    <p>{{$t('cart.cart_is_empty')}}</p>
                    <a class="btn" href="/">{{$t('cart.cart_back_to_catalog')}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
select{
    display: block;
    height: 55px;
    padding: 15px 25px;
    color: #868686;
    font-size: 16px;
    font-weight: 500;
    width: 100%;
    border-radius: 5px;
    border: 1px solid #ddd;
    text-overflow: ellipsis;
}
select:focus {
    border-color: #00bfb7;
    -webkit-box-shadow: 0 0 14px 3px rgba(0, 191, 183, 0.2);
    box-shadow: 0 0 14px 3px rgba(0, 191, 183, 0.2);
}
.order-results:nth-child(2){
    margin-top: 20px;
    padding-right: 90px;
}
</style>
